import { Timeout } from 'ahooks/lib/useRequest/src/types';

export class TimerApi {
  duration: number;

  timerId: number | Timeout | null;

  onElapsedCallback: (() => void) | null;

  constructor(duration) {
    this.duration = duration;
    this.timerId = null;
    this.onElapsedCallback = null;
  }

  initialize() {
    if (this.timerId !== null) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  start() {
    if (this.timerId === null) {
      this.timerId = setTimeout(() => {
        this.onElapsedCallback?.();
      }, this.duration);
    }
  }

  stop() {
    if (this.timerId !== null) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  onElapsed(callback) {
    this.onElapsedCallback = callback;
  }
}
